//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travExpTypeMenu', {
//        templateUrl: 'views/components/views/travExpTypeMenu/travExpTypeMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'travExpTypeMenuService', 'layoutService', function ($stateParams, stateService, translateService, modalService, travExpTypeMenuService, layoutService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let trexTypeId = $stateParams.trextype_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                tabletSize: layoutService.getMediaQueries().tablet,
//                menu: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALL

//            async function loadMenu() {
//                vm.model.menu = (await travExpTypeMenuService.getTravelExpenceType({ trextype_id: trexTypeId }))[0];
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    travExpTypeMenuService.deleteItem({ trextype_id: vm.model.menu.trextype_id }).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
